import React from 'react';
import { db } from '../../utils/firebase';
import TableComponent from '../../components/TableComponent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import AlertDialog from '../../components/AlertDialog';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import _ from 'lodash';
import { filterMultiSelectLabels } from '../../utils/miscFunctions';
import QuestionContext from '../../QuestionContext';

class MultiselectLabels extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            questions: [],
            filteredQuestions: [],
            existingRefs: [],
            questionData: null,
            page: 0,
            rowsPerPage: 10,
            openAlert: false,
            alertTitle: '',
            alertText: '',
            alertType: '',
            openSnackbar: false,
            snackbarMessage: '',
            searchTerm: ''
        }
    }

    componentDidMount() {
        db.collection("multiselect_labels").onSnapshot(querySnapshot => {
            const questions = querySnapshot.docs.map(doc => doc.data());
            this.setState({
                questions: questions,
                filteredQuestions: questions
            });
        })
    }

    updateState = (value, state) => {
        this.setState({
            [state]: value
        }, () => {
            if (state === 'searchTerm') {
                this.updateState(0, "page");
                const filteredQuestions = this.state.questions.filter(filterMultiSelectLabels(this.state.searchTerm));
                this.setState({
                    filteredQuestions: filteredQuestions
                })
            }
        })
    }

    handleQuestionChange = (value, idx, type) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy.labelArr[idx][type] = value;
        this.setState({
            questionData: dataCopy
        })
    }

    handleRefChange = (value) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy.ref = value;
        let options = [];
        this.context.forEach(question => {
            if (question.ref === value && question.type === 'multiple_choice' && question.properties.choices) {
                question.properties.choices.forEach(choice => {
                    options.push(choice.label);
                })
            }
        })
        dataCopy.options = options;
        this.setState({
            questionData: dataCopy
        })
    }

    deleteLabel = (idx) => {
        let dataCopy = { ...this.state.questionData };
        dataCopy.labelArr.splice(idx, 1);
        this.setState({
            questionData: dataCopy
        })
    }

    addLabel = () => {
        let dataCopy = { ...this.state.questionData };
        dataCopy.labelArr.push(["", ""]);
        this.setState({
            questionData: dataCopy
        })
    }

    onRowClick = async (data) => {
        let deepCloneData = _.cloneDeep(data);
        deepCloneData.labelArr = Object.entries(data.labels);
        let options = [];
        this.context.forEach(question => {
            if (question.ref === data.ref && question.type === 'multiple_choice' && question.properties.choices) {
                question.properties.choices.forEach(choice => {
                    options.push(choice.label);
                })
            }
        })
        deepCloneData.options = options;
        deepCloneData.type = 'update';
        this.setState({
            questionData: deepCloneData,
        });
    }

    toggleUpdateQuestionAlert = () => {
        this.setState({
            alertTitle: "Update this question's labels?",
            alertText: "This action can not be undone. Are you sure you want to update this question with the current labels?",
            alertType: "update"
        }, () => {
            this.toggleAlert();
        })
    }

    toggleAlert = () => {
        this.setState({
            openAlert: !this.state.openAlert
        });
    }

    toggleSnackbar = () => {
        this.setState({
            openSnackbar: !this.state.openSnackbar
        })
    }

    updateQuestionLabels = () => {
        const { questionData } = this.state;
        let newLabels = {};
        questionData.labelArr.forEach(label => {
            newLabels[label[0]] = label[1];
        });
        db.collection('multiselect_labels').doc(questionData.ref).update({
            labels: newLabels
        }).then(() => {
            console.log(`Question ${questionData.ref} was successfully edited.`);
            this.setState({
                openSnackbar: true,
                snackbarMessage: `Question ${questionData.ref} was successfully edited.`,
                openAlert: false,
                questionData: null,
            });
        }).catch(err => {
            console.log("Error updating question: ", err);
        })
    }

    toggleNewQuestion = () => {
        const newQuestionData = {
            labels: {},
            labelArr: [],
            options: [],
            ref: null,
            type: 'new',
        }
        let questionContext = [];
        this.context.forEach(question => {
            if (question.type === 'multiple_choice') {
                questionContext.push(question.ref);
            }
        })
        const uniqRefs = [...new Set(questionContext)]; //remove duplicate refs
        this.setState({
            questionData: newQuestionData,
            existingRefs: uniqRefs
        });
    }

    addNewQuestion = () => {
        const { questionData } = this.state;
        if (!questionData.ref) {
            this.setState({
                openSnackbar: true,
                snackbarMessage: "Question ref cannot be left empty."
            });
            return;
        }
        let newLabels = {};
        questionData.labelArr.forEach(label => {
            newLabels[label[0]] = label[1];
        });
        const newQuestionRef = db.collection('multiselect_labels').doc(questionData.ref);
        newQuestionRef.get().then(doc => {
            if (doc.exists) {
                this.setState({
                    openSnackbar: true,
                    snackbarMessage: "Question with this ref already exists."
                });
                return;
            } else {
                newQuestionRef.set({
                    labels: newLabels,
                    ref: questionData.ref
                }).then(() => {
                    this.setState({
                        openSnackbar: true,
                        snackbarMessage: `Question ${questionData.ref} was successfully added.`,
                        questionData: null
                    });
                }).catch(err => {
                    console.log("Error adding doc: ", err);
                })
            }
        })
    }

    render() {
        const { filteredQuestions, rowsPerPage, page, searchTerm, questionData, existingRefs, openAlert, alertTitle, alertText, snackbarMessage, openSnackbar } = this.state;

        const questionDataExists = questionData ? true : false;

        return (
            <div>
                <h3 style={{ textAlign: 'center' }}> Multiselect Labels </h3>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <TextField
                        id="search-input" variant="outlined"
                        value={searchTerm}
                        onChange={(e) => this.updateState(e.target.value, "searchTerm")}
                        InputProps={{ startAdornment: (<InputAdornment position="start"> <SearchIcon /> </InputAdornment>) }}
                        style={styles['search']}
                        autoComplete="off"
                    />
                    <Button variant="outlined" color="primary" style={{ height: 50, marginTop: 10, marginLeft: 40 }} onClick={this.toggleNewQuestion}> New Question </Button>
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <div style={{ width: '95%' }}>
                        <TableComponent
                            data={filteredQuestions}
                            headers={["Question Ref"]}
                            fields={["ref"]}
                            updateState={this.updateState}
                            onRowClick={this.onRowClick}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            count={filteredQuestions.length}
                        />
                    </div>
                    {questionData &&
                        <Dialog
                            open={questionDataExists}
                            fullWidth={true}
                            maxWidth={"md"}
                            aria-labelledby="question-dialog-title"
                        >
                            <DialogTitle id="question-dialog-title">
                                Multiselect Labels
                                {questionData.type === 'update' &&
                                    <p style={{ float: 'right', margin: 0 }}> {`Ref: ${questionData.ref}`} </p>
                                }
                            </DialogTitle>
                            <DialogContent>
                                <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', width: '100%' }}>
                                    <div style={{ width: '99%' }}>
                                        {questionData.type === 'new' &&
                                            <div style={{ width: '100%', margin: 5 }}>
                                                <Autocomplete
                                                    label="Ref"
                                                    value={questionData.ref}
                                                    onChange={(e, newValue) => this.handleRefChange(newValue)}
                                                    options={existingRefs}
                                                    style={{ width: 300 }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </div>
                                        }
                                        <h4> Labels </h4>
                                        {questionData.labelArr.map((label, idx) => (
                                            <div style={{ display: 'flex', width: '100%', margin: 5 }} key={idx}>
                                                <Autocomplete
                                                    value={label[0]}
                                                    onChange={(e, newValue) => this.handleQuestionChange(newValue, idx, 0)}
                                                    freeSolo
                                                    options={questionData.options}
                                                    style={{ width: '45%' }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            multiline
                                                            onChange={(e) => this.handleQuestionChange(e.target.value, idx, 0)}
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                                <ArrowRightAltIcon style={{ marginTop: 15 }} />
                                                <Autocomplete
                                                    value={label[1]}
                                                    onChange={(e, newValue) => this.handleQuestionChange(newValue, idx, 1)}
                                                    freeSolo
                                                    options={questionData.options}
                                                    style={{ width: '45%' }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            multiline
                                                            onChange={(e) => this.handleQuestionChange(e.target.value, idx, 1)}
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                                <IconButton aria-label="delete" onClick={() => this.deleteLabel(idx)}>
                                                    <DeleteIcon />
                                                </IconButton>
                                            </div>
                                        ))}
                                        <Button onClick={this.addLabel}> + </Button>
                                    </div>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button variant="outlined" onClick={() => this.updateState(null, 'questionData')}>Close</Button>
                                {questionData.type === 'update' ?
                                    <Button variant="outlined" onClick={this.toggleUpdateQuestionAlert}>Save Edits</Button>
                                    :
                                    <Button variant="outlined" onClick={this.addNewQuestion}>Add New Question</Button>
                                }
                            </DialogActions>
                        </Dialog>
                    }
                </div>
                <AlertDialog
                    open={openAlert}
                    title={alertTitle}
                    text={alertText}
                    noClick={this.toggleAlert}
                    yesClick={this.updateQuestionLabels}
                />
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={this.toggleSnackbar}
                    message={snackbarMessage}
                    action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={this.toggleSnackbar}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    }
                    style={{ fontSize: 14 }}
                />
            </div>
        )
    }
}

const styles = {
    'search': {
        width: '50%',
        margin: 10
    },
}

MultiselectLabels.contextType = QuestionContext;

export default MultiselectLabels;